import { useEffect, useState } from "react";
import { toast } from "sonner";
import { MessageCircle } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { brl, dt, STATUS } from "@/lib/fmt";
import { H, Panel, Table } from "./ui";

export default function Customers() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [c, setC] = useState(null);
  const load = () => api.get("/admin/customers", { params: { q: q || undefined } }).then((r) => setRows(r.data));
  useEffect(() => { load(); }, []); // eslint-disable-line
  const open = async (r) => { const d = await api.get(`/admin/customers/${r.id}`); setC({ ...d.data, whatsapp_recompra: r.whatsapp_recompra }); };
  const saveNote = async () => { await api.put(`/admin/customers/${c.id}`, { observacoes: c.observacoes }); toast.success("Observações salvas"); };
  return (
    <div data-testid="admin-customers">
      <H>Clientes</H>
      <form onSubmit={(e) => { e.preventDefault(); load(); }} className="mb-4 flex max-w-md gap-2"><input aria-label="Buscar clientes" className="input-na" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Nome, e-mail ou celular" data-testid="customers-search" /><button className="btn-line px-5">Buscar</button></form>
      <Table rows={rows} onRow={open} testid="customers-table" cols={[["nome", "Nome", (r) => <b>{r.nome}</b>], ["email", "E-mail"], ["pedidos", "Pedidos"], ["total_gasto", "Total gasto", (r) => brl(r.total_gasto)],
        ["ultima_compra", "Última compra", (r) => dt(r.ultima_compra)], ["rfm", "Segmento", (r) => <span className="rounded-full bg-na-sage2 px-2.5 py-0.5 text-xs font-semibold">{r.rfm}</span>]]} />
      <Panel open={!!c} onClose={() => setC(null)} title={c?.nome}>
        {c && (
          <div className="space-y-4 text-sm" data-testid="customer-panel">
            <p>{c.email} · {c.celular} · CPF {c.cpf || "-"}</p>
            <a className="btn-wa px-4 py-2" href={c.whatsapp_recompra} target="_blank" rel="noreferrer" data-testid="remind-repurchase"><MessageCircle className="h-4 w-4" /> Lembrar recompra (VOLTA15)</a>
            <div><p className="label-na">Consentimentos LGPD</p><pre className="rounded-2xl bg-white p-3 text-xs">{JSON.stringify(c.consentimentos, null, 2)}</pre></div>
            <div><p className="label-na">Endereços</p>{c.enderecos?.map((e) => <p key={e.id}>{e.rua}, {e.numero} - {e.cidade}/{e.uf} · {e.cep}</p>)}</div>
            <div><p className="label-na">Histórico</p>{c.historico.map((o) => <p key={o.id}>{o.numero} · {STATUS[o.status]?.label} · {brl(o.total)} · {dt(o.criado_em)} · {o.canal}</p>)}</div>
            <div><label htmlFor="obs" className="label-na">Observações</label><textarea id="obs" rows={3} className="input-na" value={c.observacoes || ""} onChange={(e) => setC({ ...c, observacoes: e.target.value })} data-testid="customer-notes" /><button className="btn-na mt-2 px-4 py-2" onClick={saveNote}>Salvar</button></div>
          </div>
        )}
      </Panel>
    </div>
  );
}

export function Subscriptions() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/admin/subscriptions").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);
  const retry = async (s) => { try { const r = await api.post(`/admin/subscriptions/${s.id}/retry`); toast[r.data.ok ? "success" : "error"](r.data.ok ? `Cobrança gerada: ${r.data.pedido}` : "Falha: cliente avisado"); load(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div data-testid="admin-subscriptions">
      <H>Assinaturas</H>
      <Table rows={rows} testid="subscriptions-table" cols={[["cliente", "Cliente", (r) => r.cliente?.nome], ["itens", "Itens", (r) => r.itens.map((i) => `${i.quantidade}x ${i.nome}`).join(", ")], ["intervalo_dias", "A cada (dias)"],
        ["proxima_cobranca", "Próxima cobrança", (r) => dt(r.proxima_cobranca)], ["status", "Status"], ["falhas", "Falhas"],
        ["a", "", (r) => r.status !== "cancelada" && <button className="btn-line px-3 py-1.5 text-xs" onClick={() => retry(r)} data-testid={`sub-retry-${r.id}`}>{r.status === "falha" ? "Nova tentativa" : "Cobrar agora"}</button>]]} />
    </div>
  );
}
